export const getCurrencySymbol = (currency?: string, locale?: string): string => {
  return (0)
    .toLocaleString(locale, {
      style: "currency",
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .replace(/\d/g, "")
    .trim()
}

export const formatCurrency = (value: number, currency?: string, locale?: string): string => {
  return value.toLocaleString(locale, { style: "currency", currency })
}

export const currencySymbol = (currency?: string, locale?: string): string => {
  const number = 0
  return number.toLocaleString(locale, { style: "currency", currency }).replace(/\d./g, "").trim()
}

export const DEFAULT_MAXIMUM_AMOUNT = 99999999
